import script from "./LimiteUnidades.vue?vue&type=script&setup=true&lang=js"
export * from "./LimiteUnidades.vue?vue&type=script&setup=true&lang=js"

import "./LimiteUnidades.vue?vue&type=style&index=0&id=ec076898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec076898"]])

export default __exports__